import { type ClassValue, clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

// `dense` is a design-system font-size rung (13px) that is not a t-shirt size, so
// stock tailwind-merge classifies `text-dense` as a text *colour*. That makes it
// mutually exclusive with text-foreground/text-muted-foreground — whichever comes
// last silently deletes the other. Registering it as a font-size restores the
// intended behaviour: text-dense conflicts with text-sm, not with text-foreground.
//
// `shadow-focus`/`shadow-focus-inset`/`shadow-focus-danger` are custom theme values
// stock tailwind-merge doesn't recognize as part of the `shadow` scale, so it can't
// tell they conflict with `shadow-none` or each other — both classes survive a
// `cn()` merge and the browser silently picks whichever the compiled stylesheet
// happens to declare last. Registering them here restores last-one-wins semantics.
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [{ text: ["dense"] }],
      shadow: ["shadow-focus", "shadow-focus-inset", "shadow-focus-danger"],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
